import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { PieChart, Pie, Sector, Cell, ResponsiveContainer } from 'recharts';



const QuestionStatics = (props) => {
  const studentResult = props.studentResult !== undefined && props.studentResult;
  const studentSummary = studentResult.summary !== undefined && studentResult.summary

  const data = [
    { name: 'Correct', value: parseInt(studentSummary.correct_question) },
    { name: 'Incorrect', value: parseInt(studentSummary.attempt_question - studentSummary.correct_question) },
    { name: 'Left', value: parseInt(studentSummary.total_question) - parseInt(studentSummary.attempt_question) },
  ];

  const COLORS = ['#22C55E', '#EF4444', '#EAB308'];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};
    return (
        <>
        <div className='card p-4 mt-4 pdf-mt-0'>
        <div className='widget_title d-flex align-items-center justify-content-between'>
            <h3>Question  Statistic</h3>
        </div>
        <div className='question_static_ContentWrap'>
          <div className='static_item'>
            <span>Total Question</span>
            <span>{studentSummary.total_question}</span>
          </div>
          <div className='static_item'>
            <span>Attempted</span>
            <span>{studentSummary.attempt_question}</span>
          </div>
        </div>
        <>
        <div style={{ width: "100%", height: "270px" }}>
        <ResponsiveContainer className="pie_chart_wrapper_static">
        <PieChart width={160} height={160}>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            height={160}
            labelLine={false}
            label={renderCustomizedLabel}
            outerRadius={130}
            innerRadius={60}
            fill="#8884d8"
            dataKey="value"
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      </div>
        </>

        <div className='question_states_wrap'>
          <div className='static_item crct_question'>
            <span>Correct Questions</span>
            <span>{studentSummary.correct_question}</span>
          </div>
          <div className='static_item incrt_question'>
            <span>Incorrect Questions</span>
            <span>{studentSummary.attempt_question - studentSummary.correct_question}</span>
          </div>
          <div className='static_item left_question'>
            <span>Left Questions</span>
            <span>{studentSummary.total_question - studentSummary.attempt_question}</span>
          </div>
        </div>
        </div>

       
        </>
        
    );
}

export default QuestionStatics